import React from "react";
import { Link } from "react-router-dom";

/**
 * HOC para capturar erros na árvore.
 * https://reactjs.org/docs/error-boundaries.html
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.error(error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <div className="text-center">
          <div className="error mx-auto" data-text="Ops!">
            Ops!
          </div>
          <p className="lead text-gray-800 mb-5">Algo não funcionou como esperado...</p>
          <p className="text-gray-500 mb-0">Um comportamento inesperado interrompeu a execução atual. </p>
          <Link
            to="/app/home"
            onClick={() => {
              this.setState({ hasError: false });
            }}
          >
            &larr; Voltar para o início
          </Link>
        </div>
      );
    }

    return children;
  }
}

export default ErrorBoundary;
